<div class="vindication-feature">
	<app-navbar title="Kontrahenci" [showReservationSearch]="false"> </app-navbar>
	<div class="vindication-body">
		<div class="vindication-top m-3">
			<mat-form-field subscriptSizing="dynamic" class="w-100">
				<mat-label>Wyszukaj po nazwie, NIPie lub adresie mailowym kontrahenta</mat-label>
				<input (keydown.enter)="onSearchEnterKey($event)" [(ngModel)]="search" matInput />

				<button class="mx-2" color="primary" mat-icon-button (click)="reloadContractors()" matSuffix>
					<i class="fas fa-search"></i>
				</button>
			</mat-form-field>
		</div>

		<div class="dynamic-table">
			<mat-table class="w-100" matSort (matSortChange)="onSortChange($event)" [dataSource]="dataSource">
				<ng-container matColumnDef="navigatorId">
					<mat-header-cell *matHeaderCellDef mat-sort-header="navigator_id">Nawigator ID</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.navigatorId }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="prefix">
					<mat-header-cell *matHeaderCellDef mat-sort-header="prefix">Prefiks</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.prefix }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="fullName">
					<mat-header-cell *matHeaderCellDef mat-sort-header="full_name">Pełna nazwa</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.fullName }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="shortName">
					<mat-header-cell *matHeaderCellDef mat-sort-header="short_name">Skrócona nazwa</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.shortName }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="nip">
					<mat-header-cell *matHeaderCellDef mat-sort-header="nip">NIP</mat-header-cell>
					<mat-cell *matCellDef="let element">{{ element.nip }}</mat-cell>
				</ng-container>

				<ng-container matColumnDef="internalStatus">
					<mat-header-cell *matHeaderCellDef mat-sort-header="internal_status__name"
						>Stan spółki</mat-header-cell
					>
					<mat-cell *matCellDef="let element">
						<app-inline-edit
							[value]="element.internalStatus?.id ?? null"
							[isLoading]="element.internalStatusLoader"
							inputType="select"
							[options]="internalStatusOptions()"
							(save)="saveInternalStatus(element, $event)"
						/>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="mail">
					<mat-header-cell *matHeaderCellDef mat-sort-header="mails">Mail</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<app-inline-edit
							[value]="element.mails"
							[isLoading]="element.mailLoader"
							inputType="mail"
							tooltip="Możesz podać kilka adresów e-mail, oddzielając je przecinkiem (np. example@gmail.com, example2@gmail.com)"
							(save)="saveMails(element, $event)"
						/>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="phone">
					<mat-header-cell *matHeaderCellDef mat-sort-header="phone">Tel.</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<app-inline-edit
							[value]="element.phone"
							[isLoading]="element.phoneLoader"
							inputType="tel"
							pattern="^(\+\d{1,3})?\s?\d{2,4}([\s\-]?\d{2,4}){1,3}$"
							(save)="savePhone(element, $event)"
						/>
					</mat-cell>
				</ng-container>

				<ng-container matColumnDef="note">
					<mat-header-cell *matHeaderCellDef>Notatka</mat-header-cell>
					<mat-cell *matCellDef="let element">
						<app-inline-edit
							[value]="element.note ?? ''"
							[isLoading]="element.noteLoader"
							inputType="text"
							(save)="saveNote(element, $event)"
						/>
					</mat-cell>
				</ng-container>

				<ng-container stickyEnd matColumnDef="contractorConfig">
					<mat-header-cell *matHeaderCellDef></mat-header-cell>
					<mat-cell *matCellDef="let element">
						<button mat-raised-button color="primary" (click)="goToContractorConfig(element.id)">
							Szczegóły
						</button>
					</mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
				<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
			</mat-table>

			@if (isLoading()) {
				<div class="spinner-container">
					<mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
				</div>
			}
		</div>
	</div>

	<mat-paginator
		[length]="length()"
		[pageSize]="pageSize()"
		[pageIndex]="pageIndex()"
		[pageSizeOptions]="[5, 10, 25, 100]"
		(page)="onPageChange($event)"
	>
	</mat-paginator>
</div>
